import { queryBuilder } from '~/api';

export const putDismissUserAlert = async (
  alertId: number
): Promise<Response> => {
  const { data } = await queryBuilder('PUT', `alerts/${alertId}/dismiss`);
  return data;
};
